export default __webpack_public_path__ + "static/media/left-side-wheel.7ad4502e.png";